import { Box } from "@mui/material";
import { Typography } from "@mui/material";
import { Grid } from "@mui/material";
import DigitalRxLogo from "../../../images/icons/DRxLogo.svg";
import IDMELogo from "../../../images/icons/IDme.svg";
import { BtnGroupStyle, DRxCheckboxStyle } from "../../../Theme";
import { YSButton } from "../../../uikit/YSButton";
import { Checkbox } from "@mui/material";
import CheckboxActive from "../../../images/icons/checkboxactive.svg";
import { useEffect, useState } from "react";
import { CircularProgress } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  setDeviceName,
  setFetch2FaUuid,
  setSetupEnabled,
  setSteps,
} from "../../../Redux/Slice/IdmeSlice";

export default function MFASetups({
  userUuidData,
  isBack,
  setIsBack,
  mfaSetupsData,
}: any) {
  const IdmePreferenceData = useSelector((state: any) => {
    return { ...state.IdmeSlice };
  }); //redux data
  const dispatch = useDispatch();
  const [loading, setLoading] = useState<boolean>(true);
  const [savePreference, setSavePreference] = useState<boolean>(false);

  useEffect(() => {
    const calculateMfaSetups = async () => {
      const filteredData = {
        generator: mfaSetupsData?.filter(
          (data: any) => data.option === "generator"
        ),
        push: mfaSetupsData?.filter((data: any) => data.option === "push"),
      };

      const selectedSetting = {
        generator: filteredData.generator.find(
          (data: any) => data.uuid === userUuidData?.settingIdentifier
        ),
        push: filteredData.push.find(
          (data: any) => data.uuid === userUuidData?.settingIdentifier
        ),
      };

      const setupType =
        IdmePreferenceData?.setup === "1" ? "generator" : "push";
      const selectedSetup = selectedSetting[setupType];

      if (selectedSetup) {
        await dispatch(setFetch2FaUuid(selectedSetup.uuid));
        await dispatch(setDeviceName(selectedSetup?.name));
        if (!isBack) {
          await dispatch(
            setSteps(IdmePreferenceData?.setup === "1" ? "four" : "five")
          );
        }
      } else {
        if (
          IdmePreferenceData?.setup === "1" &&
          filteredData.generator?.length === 1
        ) {
          if (!isBack) {
            dispatch(setSteps("four"));
          }
          dispatch(setFetch2FaUuid(filteredData.generator[0]?.uuid));
          dispatch(setDeviceName(filteredData.generator[0]?.name));
        } else if (
          IdmePreferenceData?.setup === "0" &&
          filteredData.push?.length === 1
        ) {
          if (!isBack) {
            dispatch(setSteps("five"));
          }
          dispatch(setFetch2FaUuid(filteredData.push[0]?.uuid));
          dispatch(setDeviceName(filteredData.push[0]?.name));
        }
      }
      setLoading(false);
    };

    calculateMfaSetups();
  }, [mfaSetupsData]);

  if (loading) {
    return (
      <>
        <Grid container className="logos" height={384}>
          <Grid item>
            <CircularProgress color="primary" />
          </Grid>
        </Grid>
      </>
    );
  }

  return (
    <>
      <Grid container spacing={2} height={400}>
        <Grid item xs={12}>
          <Box className="logos">
            <img src={IDMELogo} alt="ID.me" height={30} />
            <Typography
              component={"div"}
              color={"slategrey"}
              margin={0}
              padding={0}
              variant={"h3"}
              fontWeight={600}
            >
              +
            </Typography>
            <img src={DigitalRxLogo} alt="Digital_Rx" height={30} />
          </Box>
          <Box className="logos">
            <Typography
              color="primary"
              variant={"subtitle1"}
              fontWeight={600}
              textAlign={"center"}
            >
              Enter a code from you device
            </Typography>
          </Box>
          <Box className="logos" marginTop={1}>
            <Typography variant={"body2"} textAlign={"center"}>
              Choose the device you'd like to use
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} textAlign="center">
          {IdmePreferenceData?.setup === "0" && (
            <Box className="iconCheckboxes">
              {mfaSetupsData?.length > 0 &&
                mfaSetupsData?.map(
                  (each: any) =>
                    each?.option === "push" && (
                      <>
                        <Box
                          key={each?.uuid}
                          className={
                            IdmePreferenceData?.fetch2FaUuid === each?.uuid
                              ? "iconCheckbox active setup"
                              : "iconCheckbox setup"
                          }
                          onClick={() => {
                            dispatch(setFetch2FaUuid(each?.uuid));
                            dispatch(setDeviceName(each?.name));
                          }}
                        >
                          <img
                            src={CheckboxActive}
                            alt="check_box"
                            className="checkmark"
                            height={"45px"}
                          />
                          <Typography
                            component={"div"}
                            margin={0}
                            padding={0}
                            variant={"body2"}
                          >
                            {each?.name}
                          </Typography>
                        </Box>
                      </>
                    )
                )}
            </Box>
          )}
          {IdmePreferenceData?.setup === "1" && (
            <Box className="iconCheckboxes">
              {mfaSetupsData?.length > 0 &&
                mfaSetupsData?.map(
                  (each: any) =>
                    each?.option === "generator" && (
                      <>
                        <Box
                          key={each?.uuid}
                          className={
                            IdmePreferenceData?.fetch2FaUuid === each?.uuid
                              ? "iconCheckbox active setup"
                              : "iconCheckbox setup"
                          }
                          onClick={() => {
                            dispatch(setFetch2FaUuid(each?.uuid));
                            dispatch(setDeviceName(each?.name));
                          }}
                        >
                          <img
                            src={CheckboxActive}
                            alt="check_box"
                            className="checkmark"
                            height={"45px"}
                          />
                          <Typography
                            component={"div"}
                            margin={0}
                            padding={0}
                            variant={"body2"}
                          >
                            {each?.name}
                          </Typography>
                        </Box>
                      </>
                    )
                )}
            </Box>
          )}
        </Grid>

        <Grid item xs={12} md={4} textAlign="left">
          <DRxCheckboxStyle
            style={{ marginTop: 20, display: "flex", alignItems: "center" }}
          >
            <Checkbox
              id="savePreference"
              inputProps={{ "aria-label": "controlled" }}
              defaultChecked={
                userUuidData?.savedPreferenceForSetUp === null ? false : true
              }
              checked={savePreference}
              disabled={IdmePreferenceData?.fetch2FaUuid ? false : true}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setSavePreference(e.target.checked);
                dispatch(setSetupEnabled(e.target.checked));
              }}
            />
            <Typography
              className="usefreetext"
              variant="body2"
              component={"label"}
              htmlFor="savePreference"
            >
              Save this as a preference
            </Typography>
          </DRxCheckboxStyle>
        </Grid>
        <Grid item xs={12} md={4} textAlign="center">
          <Typography variant="body2" component="div" marginTop={"10px"}>
            Having trouble signing in? <br />
            Try another{" "}
            <Typography
              color="primary"
              style={{ cursor: "pointer", textDecoration: "underline" }}
              variant="body2"
              display={"inline"}
              onClick={() => {
                dispatch(setSteps("two"));
                setIsBack(true);
              }}
            >
              ways for authentication.
            </Typography>
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <BtnGroupStyle className="right">
            <YSButton
              children="Continue"
              variant="contained"
              type="submit"
              onClick={() => {
                setIsBack(false);
                IdmePreferenceData?.setup === "1"
                  ? dispatch(setSteps("four"))
                  : IdmePreferenceData?.setup === "0"
                  ? dispatch(setSteps("five"))
                  : dispatch(setSteps("fail"));
              }}
              disabled={IdmePreferenceData?.fetch2FaUuid ? false : true}
              size="large"
              className=""
            />
          </BtnGroupStyle>
        </Grid>
      </Grid>
    </>
  );
}
